import { CHANGE_PROJECT, FETCH_SELECTED_GROUP, FETCH_SELECTED_PROJECT } from '@/store/common/mutation-type'
import { computed, getCurrentInstance, ref } from '@vue/composition-api'

function useSelectProjectAndGroup () {
    const vm = getCurrentInstance().proxy
    const store = vm.$store
    const projectTypeMap = computed(() => store.getters.projectTypeMap)
    const projects = computed(() => store.getters.projects)
    const projectIdxs = computed(() => store.getters.projectIdxs)
    const changeProject = computed(() => store.getters.changeProject)
    const internalUser = computed(() => store.getters.internalUser)
    const selectedGroup = computed(() => store.getters.selectedGroup)
    const accountGroups = computed(() => store.getters.accountGroups)
    const groupProjectMap = computed(() => store.getters.groupProjectMap)
    const selectedProject = computed(() => store.getters.selectedProject)
    const myOwnProjects = computed(() => store.getters.myOwnProjects)
    const additionalProjects = computed(() => store.getters.additionalProjects)
    const selectedMonth = computed(() => store.getters.selectedMonth)
    // select group option
    // const INIT_GROUP = {gi
    //     authority: '',
    //     childGroups: [],
    //     groupIdx: [],
    //     groupName: '',
    //     groupNamePath: `Select All Group  (${accountGroups.value.length})`,
    //     projects: []
    // }
    const groupSelectable = (option) => groupProjectMap.value[option.groupIdx].length
    const groupPlaceholder = computed(() => `${vm.$t('v4.Groups')} (${accountGroups.value.length})`)

    // select project option
    const createGroupOption = item => ({ type: 'group', label: `[${item.groupName}] ${item.projectName} - ${item.usageAccountId}`, ...item })
    const createMyProjectOption = item => ({ type: 'My Project', label: `[${vm.$t('v4.My Project')}] ${item.projectName} - ${item.usageAccountId}`, ...item })
    const createAdditionalProjectOption = item => ({ type: 'Additional Project', label: `[${vm.$t('v4.Additional Project')}] ${item.projectName} - ${item.usageAccountId}`, ...item })
    const myProjectOptions = computed(() => myOwnProjects.value.map(createMyProjectOption))
    const additionalProjectOpstion = computed(() => additionalProjects.value.map(createAdditionalProjectOption))
    const groupWithOptions = computed(() => {
        return (selectedGroup.value?.groupIdx
            ? groupProjectMap.value[selectedGroup.value.groupIdx].map(createGroupOption)
            : projects.value).map(createGroupOption)
    })
    const projectOptions = computed(() => {
        if (selectedGroup.value?.groupIdx) {
            return groupWithOptions.value
        } else {
            return [].concat(myProjectOptions.value).concat(groupWithOptions.value).concat(additionalProjectOpstion.value)
        }
    })
    const projectPlaceholder = computed(() => `${vm.$t('v4.Projects')} (${projectOptions.value.length})`)

    // model
    const projectModel = ref(selectedProject.value || null)
    const groupModel = ref(selectedGroup.value || null)

    // methods
    const handleSelectGroup = (value) => {
        if (value?.groupIdx) {
            if (store.getters.groupProjectMap[value.groupIdx].length === 0) {
                return null
            }
        }

        store.commit(FETCH_SELECTED_GROUP, value)
        if (!value) {
            if (!selectedProject.value) {
                store.commit(CHANGE_PROJECT, { event: 'all', value: null })
            } else {
                // store.commit(CHANGE_PROJECT, { event: 'project', value: selectedProject.value })
            }
            return
        }
        if (value?.groupIdx && selectedProject.value) {
            // 구현필요: 그룹을 선택했고 프로젝트가 선택되어 있을때, 프로젝트가 그룹에 속하면 상태변경을 할 필요가 없음.
            // 프로젝트 선택 상태가 유지되어야 함
            store.commit(FETCH_SELECTED_PROJECT, null)
        }
        store.commit(CHANGE_PROJECT, { event: 'group', value })
    }
    /** 이 프로젝트가 속한 그룹. 어느 그룹에도 없으면 null. */
    const findGroupOfProject = (project) => {
        if (!project?.projectIdx) return null
        const map = groupProjectMap.value || {}
        const groupIdx = Object.keys(map).find(
            key => (map[key] || []).some(item => item.projectIdx === project.projectIdx)
        )
        if (!groupIdx) return null
        return (accountGroups.value || []).find(g => String(g.groupIdx) === String(groupIdx)) || null
    }

    /** 프로젝트가 하나라도 있는 첫 그룹. 빈 그룹을 고르면 화면이 또 비어버린다. */
    const firstSelectableGroup = () =>
        (accountGroups.value || []).find(g => (groupProjectMap.value?.[g.groupIdx] || []).length) || null

    const handleSelectProject = (value) => {
        /*
         * 이용내역서 화면은 "그룹 없음" 상태가 성립하지 않는다.
         *
         * 그룹만 선택되면 일괄 다운로드, 프로젝트까지 선택되면 단건 화면인데,
         * 둘 다 비면 어느 쪽도 아니어서 빈 화면이 남는다. 초기 진입이 "프로젝트 선택 +
         * 그룹 없음" 이라 프로젝트만 지우면 바로 그 상태가 된다(dev 실측).
         *
         * 그래서 프로젝트를 해제할 때 그룹이 비어 있으면 채워준다. 방금 지운 프로젝트가
         * 속한 그룹을 고르는 것이 자연스럽다 — 사용자가 한 단계 위로 올라간 셈이 된다.
         * 그 프로젝트가 어느 그룹에도 없으면(내 프로젝트·추가 프로젝트) 첫 그룹으로 둔다.
         */
        if (!value && vm.$route.name === 'invoices' && !selectedGroup.value?.groupIdx) {
            const fallback = findGroupOfProject(selectedProject.value) || firstSelectableGroup()
            if (fallback) {
                store.commit(FETCH_SELECTED_PROJECT, null)
                handleSelectGroup(fallback)
                return
            }
        }

        store.commit(FETCH_SELECTED_PROJECT, value)
        if (!value) {
            if (!selectedGroup.value?.groupIdx) {
                store.commit(CHANGE_PROJECT, { event: 'all', value: null })
            } else {
                store.commit(CHANGE_PROJECT, { event: 'group', value: selectedGroup.value })
            }
            return
        }
        if (value === null) {
            // console.error('need debug')
        }
        store.commit(CHANGE_PROJECT, { event: 'project', value })
    }
    const handleClearGroup = () => handleSelectGroup(null)
    const handleClearProject = () => handleSelectProject(null)
    // initial data
    const initialProject = computed(() => store.getters.initialProject)
    const selectGroup = (value) => store.commit(FETCH_SELECTED_GROUP, value)
    const selectProject = (value) => store.commit(FETCH_SELECTED_PROJECT, value)

    const setInitialAccountSelect = (all) => {
        if (all && !internalUser.value) return
        selectGroup(null)
        selectProject(initialProject.value)
        store.commit(CHANGE_PROJECT, { event: 'project', value: initialProject.value })
    }

    // qtype
    const qtypeParam = computed(() => {
        const params = {
            qtype: changeProject.value.event
        }
        if (!internalUser.value && params.qtype === 'all') {
            return params
        } else if (params.qtype === 'group') {
            params.groupIdx = [selectedGroup.value?.groupIdx]
            return params
        } else if (params.qtype === 'project') {
            params.projectIdx = [selectedProject.value?.projectIdx]
            return params
        } else {
            // console.error('Invalid project selection condition.')
            setInitialAccountSelect()
            return qtypeParam.value
        }
    })
    const isClearable = (cmp, cmpArr) => {
        if (cmp === 'common-select-group') {
            // 이용내역서 일괄 다운로드는 한 번의 요청 = 하나의 그룹이 전제다(설계 4.2).
            // 그룹을 해제해 "전체 그룹" 상태로 두면 대상 계정 범위가 정해지지 않으므로
            // 이 화면에서는 그룹 해제를 막는다.
            if (vm.$route.name === 'invoices') {
                return false
            }
            if (internalUser.value) {
                return cmpArr.includes('common-select-project') && !!selectedProject.value?.projectIdx
            } else {
                return true
            }
        }
        if (cmp === 'common-select-project') {
            if (internalUser.value) {
                return cmpArr.includes('common-select-group') && !!selectedGroup.value?.groupIdx
            } else {
                return vm.$route.name === 'summary' || cmpArr.includes('common-select-group') || (!cmpArr.includes('common-select-group') && cmpArr.indexOf('year') > -1 && cmpArr.indexOf('month') > -1)
            }
        }
        return false
    }

    // estimated
    const estimated = computed(() => selectedMonth.value === store.getters.months[0] && new Date().getMonth() === (Number(selectedMonth.value.substring(5, 7)) - 1))

    return {
        // common
        internalUser,
        groupProjectMap,
        projectTypeMap,
        changeProject,
        isClearable,
        selectGroup,
        selectProject,
        setInitialAccountSelect,
        estimated,
        qtypeParam,
        // group
        selectedGroup,
        groupModel,
        groupOptions: accountGroups,
        groupPlaceholder,
        groupSelectable,
        handleSelectGroup,
        handleClearGroup,
        accountGroups,

        // project
        selectedProject,
        projectModel,
        projectOptions,
        projectPlaceholder,
        projects,
        projectIdxs,
        handleSelectProject,
        handleClearProject
    }
}

export default useSelectProjectAndGroup
